var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { ref: "modal", attrs: { heading: "Fail Applicant" } }, [
    _c("h1", [_vm._v("Failing " + _vm._s(_vm.jobApplication.user.full_name))]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-4" }, [
      _c("label", [
        _vm._v(
          "Please specify the reason for failing this candidate. Please note that this reason will be included in the communications sent to this candidate."
        )
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.fail_reason,
            expression: "fail_reason"
          }
        ],
        staticClass: "bg-white rounded",
        attrs: { type: "text", name: "fail_reason" },
        domProps: { value: _vm.fail_reason },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.fail_reason = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
      _c("div", { staticClass: "cell shrink" }, [
        _c(
          "button",
          {
            staticClass: "button recycle px-5",
            attrs: { type: "button" },
            on: { click: _vm.fail }
          },
          [_vm._v("Fail")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell shrink" }, [
        _c(
          "button",
          {
            staticClass: "button warning",
            attrs: { type: "button" },
            on: { click: _vm.toggleModal }
          },
          [_vm._v("Close")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-450e1dfc", { render: render, staticRenderFns: staticRenderFns })
  }
}